import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * @description: This is meant to be used with [app-panel] component.
 * @example:
 * <app-panel>
 *   <app-panel-header>My Panel Header</app-panel-header>
 * </app-panel>
 */
@Component({
    selector: 'app-panel-header',
    templateUrl: './panel-header.component.html',
    styleUrls: ['./panel-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PanelHeaderComponent implements OnInit, OnDestroy {
  isCollapsed = new BehaviorSubject(false);

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {
    /**
     * @usage: Using subscribe to manually trigger change detection and we also subscribe to this with the appCollapsiblePanel directive.
     */
    this.isCollapsed.subscribe(() => this.changeDetector.markForCheck());
  }

  handleClick(value: boolean) {
    this.isCollapsed.next(!value);
  }

  ngOnDestroy() {
    this.isCollapsed.complete();
  }
}
